import React, {Component} from 'react';
import {Route, Routes} from 'react-router-dom';
import AppRoutes from './AppRoutes';
import {Layout} from './components/Layout';
import './custom.css';
import { Helmet } from 'react-helmet';
import AdminPanel from './admin/AdminPanel';
import LoginPage from './admin/LoginPage';

export default class App extends Component {
  static displayName = App.name;


  render() {
    return (
      <Routes>
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin/*" element={<AdminPanel />} />
        <Route path="*" element={
          <Layout>
            <Helmet>
              <meta name="keywords" content="iCandy, коляски, премиум, премиум класса, дети, детские коляски, Айкенди" />
            </Helmet>
            <Routes>
              {AppRoutes.map((route, index) => {
                const { element, ...rest } = route;
                return <Route key={index} {...rest} element={element} />;
              })}
            </Routes>
          </Layout>
        } />
      </Routes>
    );
  }
}
